import React from 'react';
import heart from '../../assets/heart.svg';
import picD from '../../assets/pic.webp';
import picT from '../../assets/pic-t.webp';
import picM from '../../assets/pic-m.webp';

const Hero = () => {
  return (
    <section id='top'>
      <div className='container tc'>
        <div className='s-40 sm-60'></div>
        <h1 className='title-intro'>
          Курсы вайб-кодинга для <img src={heart} alt='Heart' width={60} height={54} />{' '}
          украинцев
        </h1>
        <div className='s-24'></div>
        <h3 className='title-intro-sub w-60 ma'>
          Хотите в IT, но не умеете программировать?<br />

          Мы вас научим писать код с помощью ИИ!
        </h3>
        <div className='s-32'></div>
        <a href='/' className='button'>
          Начать обучение
        </a>
        <div className='s-32'></div>
        <p className='title-mini'>
          Наши онлайн курсы бесплатны
        </p>
        <div className='s-48'></div>
        <img
          src={picD}
          alt='Cources'
          width={1118}
          height={600}
          className='show-d'
        />
        <img
          src={picT}
          alt='Cources'
          width={940}
          height={504}
          className='show-t'
        />
        <img
          src={picM}
          alt='Cources'
          width={572}
          height={307}
          className='show-m'
        />
        <div className='s-48'></div>
      </div>
      <div className='back'></div>
    </section>
  );
};

export { Hero };
